import React, { useEffect, useState } from "react";
import { Play, X } from "lucide-react";
import api from "../lib/api";
import { EditableText } from "./live/Editable";

export default function VideosSection() {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/videos", { params: { active_only: true } }).then((r) => setVideos(r.data)).catch(() => {});
  }, []);

  if (videos.length === 0) return null;

  return (
    <section className="py-24 relative overflow-hidden bg-gradient-to-br from-[#04102e] via-[#061a47] to-[#0B2A6B] text-white">
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-yellow-400/10 rounded-full blur-3xl animate-blob" />
      <div className="absolute -bottom-20 right-0 w-96 h-96 bg-blue-400/15 rounded-full blur-3xl animate-blob" style={{ animationDelay: "3s" }} />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <EditableText path="home.videos.kicker" as="p" className="inline-block px-3 py-1 rounded-full bg-yellow-400/15 border border-yellow-400/30 text-yellow-300 text-xs font-bold tracking-wider uppercase mb-3">
            Video Updates
          </EditableText>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
            <EditableText path="home.videos.heading" as="span">
              Take a peek inside Kiki Centre
            </EditableText>
          </h2>
          <EditableText path="home.videos.subtitle" as="p" multiline className="text-slate-300 mt-4">
            Campus tours, student stories, and industry updates straight from our YouTube channel.
          </EditableText>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((v, i) => {
            const thumb = v.thumbnail_url || `https://img.youtube.com/vi/${v.youtube_id}/hqdefault.jpg`;
            return (
              <button
                key={v.id}
                onClick={() => setActive(v)}
                className="group text-left bg-white/5 backdrop-blur border border-white/10 rounded-2xl overflow-hidden hover:bg-white/10 hover:border-yellow-400/40 transition tilt-card animate-fade-up"
                style={{ animationDelay: `${i * 0.08}s` }}
              >
                <div className="relative aspect-video overflow-hidden">
                  <img src={thumb} alt={v.title} className="absolute inset-0 w-full h-full object-cover zoom-img" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="h-16 w-16 rounded-full bg-yellow-400/95 flex items-center justify-center group-hover:scale-110 transition shadow-2xl animate-pulse-glow">
                      <Play className="h-7 w-7 text-[#0B2A6B] fill-current ml-1" />
                    </div>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-bold text-white text-base mb-1 line-clamp-2 group-hover:text-yellow-400 transition">{v.title}</h3>
                  {v.description && (
                    <p className="text-sm text-slate-300 line-clamp-2">{v.description}</p>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Modal */}
      {active && (
        <div
          className="fixed inset-0 z-[80] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-5 right-5 h-11 w-11 rounded-full bg-white/10 hover:bg-yellow-400 hover:text-[#0B2A6B] text-white flex items-center justify-center transition"
          >
            <X className="h-5 w-5" />
          </button>
          <div
            className="w-full max-w-5xl aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <iframe
              src={`https://www.youtube.com/embed/${active.youtube_id}?autoplay=1`}
              title={active.title}
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
}
